export interface TypeKeys {
  id: number
  key: string
  deletedAt: Date | null
}

export interface TypeMapping {
  alias: string
  id: string
  type: MappingTypeNames
  typeId: number | null
  key: string | null
}

export const DEFAULT_PAGE_SIZE = 10

export const MappingTypeNames = {
  PRODUCT: "PRODUCT",
  MATERIAL: "MATERIAL",
  STANDARD: "STANDARD",
} as const

export type MappingTypeNames =
  (typeof MappingTypeNames)[keyof typeof MappingTypeNames]

export type Pagination = {
  totalPages: number
  currentPage: number
  onPageChange: (page: number) => void
}

export type MappingCollapseProps = {
  isOpen: boolean
  close: () => void
  open: () => void
}
